import { Fabric8Tool } from '../../models/tool.model';
import { Fabric8ToolType } from '../Fabric8ToolType';

export const measureTool: Fabric8Tool = {
  name: 'guide|line',
  type: Fabric8ToolType.GUIDE,
  radius: 1,
  enabled: true,
};
